import React from 'react';
import { Reveal } from './Reveal';
const audiences = ['Tarot Readers & Card Practitioners', 'Spiritual Coaches & Holistic Practitioners', 'Energy Healers & Wellness Professionals', 'Anyone Building a Serious Therapeutic Practice', 'Practitioners Ready to Charge Premium Prices', 'Anyone Struggling With Burnout or Energy Depletion'];
export function ProfessionalAudience() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-195" data-mp="72eq2lylgc7w">
      <Reveal className="mx-auto max-w-5xl text-center" data-id="element-196" data-mp="73y5ybgc8l95">
        <h2 className="font-serif text-4xl leading-tight text-navy sm:text-5xl" data-id="element-197" data-mp="bzdin02m0b3z">
          🔮 Designed for Serious <span className="text-sage" data-id="element-198" data-mp="g2tdprz163ek">Therapeutic Practitioners</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-199" data-mp="l0bo7msp4qoo">
          If you work with tarot therapeutically, build meaningful client relationships, or want a
          complete professional reference system — this library was built for you.
        </p>
        <ul className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-200" data-mp="1a1rh850ymvzj">
          {audiences.map(audience => <li key={audience} className="rounded-full border border-amber/50 bg-surface px-4 py-2.5 text-sm font-semibold text-navy shadow-premium" data-id="element-201" data-mp="159q8gt303ne9">
              ✅ {audience}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}